import { cacheUnaryFunction } from '@morphic-ts/common/es6/core';
import { modelEqInterpreter } from '@morphic-ts/eq-interpreters/es6/interpreters';
import { modelIoTsNonStrictInterpreter, modelIoTsStrictInterpreter } from '@morphic-ts/io-ts-interpreters/es6/interpreters';
import { modelShowInterpreter } from '@morphic-ts/show-interpreters/es6/interpreters';
import { makeSummoner } from '@morphic-ts/summoners';
/**
 *  @since 0.0.1
 */
export const AsOpaque = () => (x) => x;
/**
 *  @since 0.0.1
 */
export const AsUOpaque = () => (x) => x;
/**
 *  @since 0.0.1
 */
export const summonFor = (env) => makeSummoner(cacheUnaryFunction, program => {
    const { create, type } = program(modelIoTsNonStrictInterpreter())(env);
    return {
        build: a => a,
        eq: program(modelEqInterpreter())(env).eq,
        show: program(modelShowInterpreter())(env).show,
        strictType: program(modelIoTsStrictInterpreter())(env).type,
        type,
        create
    };
});
